import { useFiltersV2Actions } from "PFApp/components/filters_v2";
import { Meta } from "PFTypes";
import { useCallback } from "react";

export const useSyncFiltersV2Meta = () => {
  const { setFilters, setFiltersCollection, setSearchId, setScope } = useFiltersV2Actions();

  return useCallback(
    (meta?: Partial<Meta>) => {
      if (!meta) {
        return;
      }

      if (meta.target) {
        setFiltersCollection(meta.target);
      }

      // TODO: [SP-2590] Remove `search_id` support when all collections use axios
      setSearchId(meta.searchId || meta.search_id);

      if (!meta.filtersV2) {
        return;
      }

      setFilters(meta.filtersV2);
      setScope(meta.total);
    },
    [setFilters, setFiltersCollection, setScope, setSearchId]
  );
};
